import tagsField from './components/tagsField'

export default (Alpine) => {
  Alpine.data('resourcererTagsField', tagsField)
}
